/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { VehicleVoModel } from '@well/delivery-libs/vehicle-management/domain';

export class ShipmentVehicleDtoModel extends JSONable {
  uuid: string | null = null;
  owner: string | null = null;
  licencePlate: string | null = null;
  vehicleType: string | null = null;
  vehicleVO: VehicleVoModel | null = null;
  shipmentBaseUuid: string | null = null;
}
